import * as React from "react";
import { useSelector } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DashboardUserView from "./userView";
import DashboardFuncView from "./funcView";
const defaultTheme = createTheme();

export default function Dashboard() {
  const userData = useSelector((state) => state.userData);

  return (
    <ThemeProvider theme={defaultTheme}>
      {userData.funcionario ? <DashboardFuncView /> : <DashboardUserView />}
    </ThemeProvider>
  );
}
